export default __webpack_public_path__ + "static/media/ae.e3396fd0.svg";